<div class="dialog">
  <div class="dialog-background" (click)="close()"></div>

  <div class="dialog-content" *ngIf="!success">
    <div class="content">
      <h2>{{ 'modals.consultation.h2' | translate }}</h2>
      <p [innerHtml]="'modals.consultation.p' | translate"></p>
      <div class="inner-content">
        <div class="day-picker">
          <p>{{ 'account.reminder.date' | translate }}</p>
          <div>
            <span *ngIf="showBackButton" (click)="otherDay(-1)" class="icon-i-arrow-back"></span>
            <span class="icon-i-calendar"></span>
            <span>{{ day }}</span>
            <span (click)="otherDay(1)" class="icon-i-arrow-forward"></span>
          </div>
        </div>
        <div class="time-picker">
          <p>{{ 'account.reminder.time' | translate }}</p>
          <div>
            <span *ngIf="timeIndex > 0" (click)="otherTime(-1)" class="icon-i-arrow-back"></span>
            <span class="icon-i-time"></span>
            <span>{{ timesArray[timeIndex] }} - {{ timesArray[timeIndex + 1] }}</span>
            <span *ngIf="timeIndex < timesArray.length - 2" (click)="otherTime(1)" class="icon-i-arrow-forward"></span>
          </div>
        </div>
      </div>
      <div class="inner-content">
        <h3>{{ 'modals.consultation.callType' | translate }}</h3>
        <div class="row">
          <div [ngClass]="currentLang === 'en' ? 'col-3 col-sm-4 col-xs-5' : 'col-4 col-sm-4 col-xs-6'">
            <label for="video">
              <input
                class="form-radio"
                name="callType"
                type="radio"
                [checked]="callType === 'video'"
                value="video"
                id="video"
                (click)="selectedCallType('video')"
              />
              <span class="radio-label">{{ 'modals.consultation.video' | translate }}</span>
            </label>
          </div>
          <div [ngClass]="currentLang === 'en' ? 'col-3 col-sm-4 col-xs-5' : 'col-4 col-sm-4 col-xs-6'">
            <label for="phone">
              <input
                class="form-radio"
                name="callType"
                type="radio"
                [checked]="callType !== 'video'"
                value="phone"
                id="phone"
                (click)="selectedCallType('phone')"
              />
              <span class="radio-label">{{ 'modals.consultation.phone' | translate }}</span>
            </label>
          </div>
          <div [ngClass]="currentLang === 'en' ? 'col-6 col-sm-12 col-xs-12' : 'col-8 col-sm-12 col-xs-12'">
            <div id="phoneDetail" *ngIf="callType === 'phone'" [ngClass]="{ invalid: isInvalid }">
              <p>{{ 'modals.consultation.yourPhone' | translate }}</p>
              <input
                type="tel"
                [(ngModel)]="consultationPhone"
                (input)="isInvalid ? validPhoneFormat() : ''"
                placeholder="{{ 'modals.consultation.placeholder' | translate }}"
              />
              <span *ngIf="isInvalid" class="error">{{ 'personal.error.bad_phone' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-content">
        <h3>{{ 'modals.consultation.more' | translate }}</h3>
        <p>{{ 'modals.consultation.share' | translate }}</p>
        <textarea placeholder="" [(ngModel)]="consultationNote"></textarea>
      </div>
      <div class="ui-button-group reverse">
        <button (click)="close(); trackCTA('Consultation modal CTA => Cancel')" class="ui-button secondary">
          {{ 'modals.consultation.cta.cancel' | translate }}
        </button>
        <button (click)="book()" class="ui-button" [disabled]="loading">{{ 'modals.consultation.cta.book' | translate }}</button>
      </div>
    </div>
  </div>

  <div class="dialog-content" id="consultation-confirmation" *ngIf="success">
    <h2>{{ 'modals.consultation.ok.title' | translate }}</h2>
    <p>{{ 'modals.consultation.ok.p' | translate }}</p>
    <p><span class="icon-i-calendar"></span>{{ timesArray[timeIndex] }} - {{ timesArray[timeIndex + 1] }}, {{ day }}</p>
    <p>
      <span class="icon-i-phone"></span>{{ (callType === 'video' ? 'modals.consultation.video' : 'modals.consultation.phone') | translate }}
    </p>
    <p>
      <span class="icon-i-location"></span>
      <ng-container *ngIf="callType === 'video'">
        {{ 'modals.consultation.extra_info' | translate }}
      </ng-container>
      <ng-container *ngIf="callType !== 'video'">
        <span>{{ consultationPhone }}</span>
      </ng-container>
    </p>
    <button (click)="close(); trackCTA('Consultation modal CTA => OK')" class="ui-button full-width">
      {{ 'modals.consultation.ok.cta' | translate }}
    </button>
  </div>
</div>
